import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';

import { FeedbackService } from './shared/services/feedback/feedback.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[];

  constructor(private titleService: Title, private feedbackService: FeedbackService) {
    this.subscriptions = [];
  }

  ngOnInit() {
    // Handling online / offline events
    window.addEventListener('offline', () => {
      this.feedbackService.showMessage({
        message: 'misc.modals.offline',
        title: 'misc.modals.error-title',
        decoration: 'none',
        type: 'offline',
        titleDefault: 'Oops...',
        keyboard: false
      });
    });

    this.titleService.setTitle('Intern Ideta');
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription: Subscription) => subscription?.unsubscribe());
  }
}
